export default function PlayIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M380.63,112.03c-17.09-16.2-36.69-28.88-57.88-37.66-21.1-8.74-43.79-13.62-67.2-14.29-52.75-1.5-104.01,19.08-141.02,56.7-35.17,35.75-54.53,83-54.53,133.22s19.77,98.47,55.65,134.35c35.88,35.88,83.6,55.65,134.35,55.65s98.47-19.77,134.35-55.65c35.37-35.37,55.09-82.25,55.64-132.2.58-52.84-21.01-103.77-59.36-140.12ZM318.51,254.98l-108.52,62.65c-3.77,2.18-8.49-.54-8.49-4.9v-125.3c0-4.36,4.72-7.09,8.49-4.91l108.52,62.65c3.77,2.18,3.77,7.63,0,9.81Z"/>
    </svg>
  );
}
